export default __webpack_public_path__ + "static/media/Benefit.46366808.svg";